export const CARGO_QUOTES_RESET_STATE = 'CARGO_QUOTES_RESET_STATE';
export const CARGO_QUOTES_CURRENT_ITEM = 'CARGO_QUOTES_CURRENT_ITEM';

export const CARGO_QUOTES_REQUEST_LOADING = 'CARGO_QUOTES_REQUEST_LOADING';
export const CARGO_QUOTES_REQUEST_SUCCESS = 'CARGO_QUOTES_REQUEST_SUCCESS';
export const CARGO_QUOTES_REQUEST_FAILED = 'CARGO_QUOTES_REQUEST_FAILED';

export const CARGO_QUOTES_CURRENT_ACTION = 'CARGO_QUOTES_CURRENT_ACTION';
export const CARGO_QUOTES_RESET_ACTION = 'CARGO_QUOTES_RESET_ACTION';